import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Select, SelectTrigger, SelectValue, SelectContent, SelectItem,
} from "@/components/ui/select";
import { Phone, Mail, Calendar as CalendarIcon, MessageSquare } from "lucide-react";
import { toast } from "sonner";

const STATUSES = ["new", "contacted", "booked", "closed"];

export default function InquiriesPage() {
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    const { data } = await api.get("/inquiries");
    setItems(data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const updateStatus = async (id, status) => {
    await api.put(`/inquiries/${id}/status?status=${status}`);
    toast.success(`Marked as ${status}`);
    load();
  };

  return (
    <div className="space-y-5 fade-up" data-testid="inquiries-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Booking inquiries</h1>
        <p className="text-sm text-muted-foreground mt-1">Patient requests from your public site. {items.filter(i => i.status === "new").length} new.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((q) => (
          <Card key={q.id} data-testid={`inquiry-${q.id}`}>
            <CardContent className="p-5">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0 flex-1">
                  <div className="font-semibold">{q.name}</div>
                  <div className="text-xs text-muted-foreground mono mt-0.5">{new Date(q.created_at).toLocaleString()}</div>
                </div>
                <Badge variant={q.status === "new" ? "default" : "outline"}>{q.status}</Badge>
              </div>
              <div className="mt-3 space-y-1.5 text-sm">
                <div className="flex items-center gap-2"><Phone className="size-3.5 text-muted-foreground" /><span className="mono text-xs">{q.phone}</span></div>
                {q.email && <div className="flex items-center gap-2"><Mail className="size-3.5 text-muted-foreground" /><span className="text-xs">{q.email}</span></div>}
                {q.preferred_date && <div className="flex items-center gap-2"><CalendarIcon className="size-3.5 text-muted-foreground" /><span className="text-xs">{new Date(q.preferred_date).toLocaleString()}</span></div>}
                {q.reason && <div className="flex items-start gap-2 pt-1.5"><MessageSquare className="size-3.5 text-muted-foreground mt-0.5" /><span className="text-xs">{q.reason}</span></div>}
              </div>
              <div className="mt-4 pt-4 border-t border-border">
                <Select value={q.status} onValueChange={(v) => updateStatus(q.id, v)}>
                  <SelectTrigger className="h-8" data-testid={`inquiry-status-${q.id}`}><SelectValue /></SelectTrigger>
                  <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                </Select>
              </div>
            </CardContent>
          </Card>
        ))}
        {items.length === 0 && (
          <Card className="md:col-span-2"><CardContent className="p-10 text-center text-muted-foreground">No inquiries yet.</CardContent></Card>
        )}
      </div>
    </div>
  );
}
